import { render, staticRenderFns } from "./RequestFabricAccessory.vue?vue&type=template&id=251bf491&scoped=true&"
import script from "./RequestFabricAccessory.vue?vue&type=script&lang=js&"
export * from "./RequestFabricAccessory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251bf491",
  null
  
)

export default component.exports